import { RequestResponsePattern } from "../../../../../types/Request"
import { getApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."



export default async function getConfiguracaoApp(setTexto: Function, setEmail: Function, setTextoAcompanhado: Function, setFile: Function) {
    try {

        const endpoint = DOMAIN
        const params = `/configuracaoapp/one`
        const response: RequestResponsePattern<any> = await getApi({ endpoint, params })

        if (response) {

            if (!response.flagErro) {
                setTexto(response.listaResultados.textoPadrao)
                setEmail(response.listaResultados.emailPadrao)
                setTextoAcompanhado(response.listaResultados.textoAcompanhamento)


                if (true) {

                    const byteCharacters = atob(response.listaResultados.arquivo);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteArrays.push(byteCharacters.charCodeAt(i));
                    }
                    const pathArquivo = response.listaResultados.urlArquivo as string

                    const nomeArquivo = pathArquivo.split(/[\/\\]/).at(-1)
                    console.log(nomeArquivo, pathArquivo)
                    const blob = new Blob([new Uint8Array(byteArrays)], { type: 'application/pdf' });
                    const file = new File([blob], nomeArquivo ?? '', { type: 'application/pdf' });
                    const url = URL.createObjectURL(file)
                    localStorage.setItem('pdf-view', url)

                    setFile(file)

                }

            } else throw new Error(response.listaMensagens[0])
        } else throw new Error('Erro na requisição')
    } catch (error: any) {
        console.log(error)

    }
}